import {Component, Input} from '@angular/core';
import {BlockContent} from '../../article/article.component';

@Component({
    selector: 'app-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss'],
})
export class BannerComponent {
    @Input() content!: BlockContent;

    constructor() {}
}
